module.exports = "/_next/static/images/MaturityModelImageSm-f47f1ae098ba5bf72d5dba93aca0edb5.png";